import { useFetch } from "react-admin-base";
import { FormattedMessage } from "react-intl";
import { Link, Route, Switch } from "react-router-dom";
import { CardBody } from "reactstrap";
import { Card } from "reactstrap";
import { Col, Row } from "reactstrap";
import Avatar from "../../Components/Avatar";
import DataLoader from "../../Components/DataLoader";
import Mentor, { MentorEditPage } from "./Mentor";

function MentorCard({ value }) {
	return <Card>
		<CardBody>
			<Avatar user={value.user} className="mb-3" />
			<h3>{value.user.name}</h3>
			
			<p>{value.about}</p>
			
			<p className="mb-0">
				<Link to={"/mentor/"+value.user.id}>
					<FormattedMessage id="MORE" />
				</Link>
			</p>
		</CardBody>
	</Card>;
}

export default function Mentors() {
	const [ mentors ] = useFetch('/mentor');
	
	if (!mentors)
		return null;
	
	return <Switch>
		<Route path="/mentor/:id/edit" component={MentorEditPage} />
		<Route path="/mentor/:id" component={Mentor} />
		<Row>
			<DataLoader url="/mentor">
			{
				row => <Col md="4" key={row.user.id}>
					<MentorCard  value={row} />
				</Col>
			}
			</DataLoader>
		</Row>
	</Switch>;
}


